import { api, getApiBaseUrl } from "./apiClient";
import { getToken } from "@/utils/auth";

export const cobranzaService = {
  getSolicitudes: (ownerId: string, filtroCriterio?: string, filtroValor?: string) => {
    const params = new URLSearchParams();
    params.append('ownerID', ownerId);
    if (filtroCriterio) params.append('filtroCriterio', filtroCriterio);
    if (filtroValor) params.append('filtroValor', filtroValor);
    return api.get<any[]>(`/cobranza/solicitudes?${params.toString()}`);
  },

  getReporteCobranzaReferenciada: async (ownerId: string) => {
    const token = getToken();
    const headers: HeadersInit = {};
    if (token) headers['Authorization'] = `Bearer ${token}`;

    const response = await fetch(`${getApiBaseUrl()}/cobranza/reporte?ownerID=${ownerId}`, {
      method: 'GET',
      headers,
      credentials: 'include',
    });
    
    if (!response.ok) {
      throw new Error('Error al generar reporte');
    }
    
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'CobranzaReferenciada.csv';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  },
};
